import type { WellIndexType } from '@go-widgets/well-logs-widget';
import { action, makeObservable, observable } from 'mobx';

import type { Stack } from 'src/packages/data/structures/Stack';

import type { BaseSettingsScreen } from '../screen/BaseSettingsScreen';

import { dummyCollapses } from './ObjectsListScreen';
import type { ObjectListScreenEntity } from './ObjectsListScreen.entity';

export class ObjectsListScreenStore {
  readonly stack: Stack<BaseSettingsScreen>;
  readonly screenEntity: ObjectListScreenEntity;

  @observable activeObjectCollapses: string[] = dummyCollapses.map((collapse) => collapse.id);

  constructor(stack: Stack<BaseSettingsScreen>, screen: ObjectListScreenEntity) {
    this.stack = stack;
    this.screenEntity = screen;

    makeObservable(this);
  }

  @action.bound
  selectObject(id: WellIndexType): void {
    if (id === this.screenEntity.selectedObjectKey) return;

    this.stack.setLength(1);
    this.screenEntity.setObjectKey(id);
    this.screenEntity.createWidgetTemplatesList(id);
  }

  @action.bound
  openObjectCollapse(key: string[]): void {
    this.activeObjectCollapses = key;
  }
}
